import React from "react";
import { uiNotification } from "../../../../../../../services/UINotificationService";
import { useAppTranslation } from "../../../../../../../i18n/useAppTranslation";
import { CircularProgress } from "../../../../../../../shared/CircularProgress/CircularProgress";
import { composeDownloadDataUrl } from "../../../../../../../utilities/api";
import { useExportPricingVariationMutation } from "../../../../../../../api/mutations/useExportPricingVariationMutation";
import { Button } from "../../../../../../../shared/Button/Button";

export const DownloadButton = ({ searchTerm }) => {
  const { tCommon } = useAppTranslation.Common();

  const { mutateAsync, isLoading } = useExportPricingVariationMutation({
    onError: () => {
      uiNotification.error(tCommon("error.export"));
    },
  });

  const initiate = () => {
    mutateAsync({
      term: searchTerm,
    }).then((res) => {
      window.open(composeDownloadDataUrl(res.file), "_blank");
    });
  };

  return (
    <Button
      size="small"
      className="m-r-5"
      isDisabled={isLoading}
      onClick={initiate}
      leftAdornment={
        isLoading ? <CircularProgress size="small" color="white" /> : undefined
      }
    >
      {tCommon("label.downloadExcel")}
    </Button>
  );
};
